import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const categoryValidationSchema = t =>
  yup.object().shape({
    name: yup
      .string()
      .required(t(translations.validation.required()))
      .label(t(translations.pages.leihbar.category.create.name()))
  });
